import { motion } from 'framer-motion'
import ScrollReveal from '../shared/ScrollReveal'
import GradientText from '../shared/GradientText'
import { Icons } from '../shared/Icons'
import './MobileSection.css'

const mobileFeatures = [
  'Live Monitor',
  'Battery Control',
  'DC Analysis',
  'Workforce Tasks',
  'Visual Inspections',
  'Diagnostics'
]

const supportedLanguages = ['EN', 'DE', 'ES', 'FR', 'IT', 'NL', 'PL', 'PT', 'RO', 'EL']

export default function MobileSection() {
  return (
    <section className="mobile-section" id="mobile">
      <div className="container">
        <div className="mobile-grid">
          <div className="mobile-content">
            <ScrollReveal>
              <span className="mobile-badge">// WEB + MOBILE · CROSS-PLATFORM</span>
            </ScrollReveal>

            <ScrollReveal delay={0.1}>
              <h2 className="mobile-title">
                Two apps.{' '}
                <GradientText gradient="solar">One system.</GradientText>
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <p className="mobile-description">
                A native mobile app keeps field crews in sync with the web portal — same data,
                same alerts, same tasks. Real-time two-way sync. Role-based access for crews,
                engineers, and managers. Wherever you are.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.3}>
              <div className="mobile-stats">
                <div className="mobile-stat">
                  <span className="mobile-stat-value">Real-time</span>
                  <span className="mobile-stat-label">Two-way sync</span>
                </div>
                <div className="mobile-stat">
                  <span className="mobile-stat-value">Role-based</span>
                  <span className="mobile-stat-label">Crews · Engineers · Managers</span>
                </div>
                <div className="mobile-stat">
                  <span className="mobile-stat-value">Dark + Light</span>
                  <span className="mobile-stat-label">Both modes, all platforms</span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.35}>
              <div className="mobile-languages">
                <span className="mobile-languages-label">10+ languages</span>
                <div className="mobile-languages-list">
                  {supportedLanguages.map((lang) => (
                    <span key={lang} className="mobile-lang-chip">{lang}</span>
                  ))}
                  <span className="mobile-lang-more">MORE ADDED</span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.4}>
              <div className="mobile-features">
                {mobileFeatures.map((feature, i) => (
                  <motion.span
                    key={i}
                    className="mobile-feature-chip"
                    whileHover={{ scale: 1.05, y: -2 }}
                  >
                    {feature}
                  </motion.span>
                ))}
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.5}>
              <div className="mobile-platforms">
                <div className="platform-badge">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                  </svg>
                  <span>iOS</span>
                </div>
                <div className="platform-badge">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.523 2.047c-.31-.32-.846-.315-1.197.012l-4.326 4.028-4.326-4.028c-.351-.327-.887-.332-1.197-.012-.31.32-.283.837.06 1.152l4.462 4.154-4.462 4.154c-.343.315-.37.832-.06 1.152.31.32.846.315 1.197-.012l4.326-4.028 4.326 4.028c.351.327.887.332 1.197.012.31-.32.283-.837-.06-1.152l-4.462-4.154 4.462-4.154c.343-.315.37-.832.06-1.152zM2.992 17.5h18.016c.546 0 .992.446.992.992v.016c0 .546-.446.992-.992.992H2.992C2.446 19.5 2 19.054 2 18.508v-.016c0-.546.446-.992.992-.992z"/>
                  </svg>
                  <span>Android</span>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal animation="fadeRight" className="mobile-visual">
            <div className="phone-mockups">
              {/* iPhone mockup - Live Monitor */}
              <motion.div
                className="phone phone-primary"
                initial={{ y: 20, rotate: -5 }}
                whileInView={{ y: 0, rotate: -5 }}
                whileHover={{ y: -10, rotate: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="phone-notch" />
                <div className="phone-screen">
                  <img
                    src="/images/mobile/ios-live-monitor-dark.png"
                    alt="Live Monitor - Real-time solar monitoring"
                    className="phone-screenshot"
                  />
                </div>
              </motion.div>

              {/* Android mockup - Alerts */}
              <motion.div
                className="phone phone-secondary"
                initial={{ y: -20, rotate: 5 }}
                whileInView={{ y: 0, rotate: 5 }}
                whileHover={{ y: -10, rotate: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="phone-screen">
                  <img
                    src="/images/mobile/ios-alerts-dark.png"
                    alt="Alert Management - Real-time notifications"
                    className="phone-screenshot"
                  />
                </div>
              </motion.div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
